module.exports = __webpack_public_path__ + "static/img/bg13.7513626.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg13.jpg
// module id = czKV
// module chunks = 1